import { isValidDNI, isValidNIE } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { optionalDialCode, requiredEmail, requiredError, requiredMessage, requiredPhoneNumber, requiredString } from '@/utils/zodUtils';

export const ShortContactFormBaseSchema = (t: GetTextIdTranslationType) =>
  z.object({
    firstName: requiredString(t),
    lastName: requiredString(t),
    dialCode: optionalDialCode,
    phoneNumber: requiredPhoneNumber(t),
    email: requiredEmail(t),
    documentNumber: requiredString(t).refine((value) => isValidDNI(value) || isValidNIE(value), {
      message: t('INVALID_DOCUMENT_NUMBER'),
    }),
    optIn: z.boolean(requiredError(t)).refine((value) => value, requiredMessage(t)),
  });

export type ShortContactFormType = z.infer<ReturnType<typeof ShortContactFormBaseSchema>>;
